<ecoupon-shared-ui-lip-ecoupon-header [imgHeader]="imgHeader()"></ecoupon-shared-ui-lip-ecoupon-header>
<router-outlet></router-outlet>
